// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

.image-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(2, 6, 12, 0.04);
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  width: 220px;
}

.image-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(2, 12, 6, 0.08);
  border-color: rgba(22, 163, 74, 0.35);
}

.image-card__media {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #f0fdf4;
}

.image-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-card__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  border-top: 1px solid var(--color-border);
  background: #fafafa;
}

.btn-download {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--color-primary);
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid var(--color-primary-700);
  transition: transform 0.1s ease, box-shadow 0.15s ease, background 0.2s ease;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.28);
}

.btn-download:hover {
  transform: translateY(-1px);
  background: var(--color-primary-500);
}

.image-card__name {
  font-size: 16px;
  padding: 10px 12px;
  color: #334155;
  word-break: break-all;
  text-align: center;
  font-weight: 600;
}

/* Mobile: two columns for images, centered last item */
@media (max-width: 430px) {
  .image-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    justify-items: center;
  }
  
  /* When there's an odd number of items, center the last item across both columns */
  .image-grid .image-card:last-child:nth-child(odd) {
    grid-column: 1 / -1;
    justify-self: center;
  }
  
  .image-card {
    width: 100%;
    max-width: 180px;
    min-width: 160px;
  }
  .image-card__media {
    aspect-ratio: 1 / 1; /* square thumbnails on mobile */
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ImageCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,4EAA4E;EAC5E,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;EACvB;;EAEA,kFAAkF;EAClF;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB,EAAE,gCAAgC;EACvD;AACF","sourcesContent":[".image-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: center;\n}\n\n.image-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(2, 6, 12, 0.04);\n  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  width: 220px;\n}\n\n.image-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(2, 12, 6, 0.08);\n  border-color: rgba(22, 163, 74, 0.35);\n}\n\n.image-card__media {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  background: #f0fdf4;\n}\n\n.image-card__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.image-card__actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 12px;\n  border-top: 1px solid var(--color-border);\n  background: #fafafa;\n}\n\n.btn-download {\n  display: inline-block;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: var(--color-primary);\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 13px;\n  border: 1px solid var(--color-primary-700);\n  transition: transform 0.1s ease, box-shadow 0.15s ease, background 0.2s ease;\n  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.28);\n}\n\n.btn-download:hover {\n  transform: translateY(-1px);\n  background: var(--color-primary-500);\n}\n\n.image-card__name {\n  font-size: 16px;\n  padding: 10px 12px;\n  color: #334155;\n  word-break: break-all;\n  text-align: center;\n  font-weight: 600;\n}\n\n/* Mobile: two columns for images, centered last item */\n@media (max-width: 430px) {\n  .image-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    justify-items: center;\n  }\n  \n  /* When there's an odd number of items, center the last item across both columns */\n  .image-grid .image-card:last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n    justify-self: center;\n  }\n  \n  .image-card {\n    width: 100%;\n    max-width: 180px;\n    min-width: 160px;\n  }\n  .image-card__media {\n    aspect-ratio: 1 / 1; /* square thumbnails on mobile */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
